import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../api';
import { toast } from 'react-toastify';

// Async thunks
export const getWebShopSettings = createAsyncThunk(
  'webshop/getSettings',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.getWebShopSettings();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createWebShopSettings = createAsyncThunk(
  'webshop/createSettings',
  async (settingsData, { rejectWithValue }) => {
    try {
      const { data } = await api.createWebShopSettings(settingsData);
      toast.success('Web shop postavke su uspešno kreirane');
      return data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'Greška pri kreiranju web shop postavki';
      toast.error(errorMessage);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateWebShopSettings = createAsyncThunk(
  'webshop/updateSettings',
  async (settingsData, { rejectWithValue }) => {
    try {
      const { data } = await api.updateWebShopSettings(settingsData);
      toast.success('Web shop postavke su uspešno ažurirane');
      return data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'Greška pri ažuriranju web shop postavki';
      toast.error(errorMessage);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const webshopSlice = createSlice({
  name: 'webshop',
  initialState: {
    settings: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearWebShopSettings: (state) => {
      state.settings = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get settings
      .addCase(getWebShopSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWebShopSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(getWebShopSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create settings
      .addCase(createWebShopSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createWebShopSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(createWebShopSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update settings
      .addCase(updateWebShopSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateWebShopSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(updateWebShopSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearWebShopSettings } = webshopSlice.actions;
export default webshopSlice.reducer;

